const actions = {
  SET_STATE: 'authorizationCodes/SET_STATE',
  CREATE_AUTHORIZATION: 'authorization/CREATE_AUTHORIZATION',
  EDIT_AUTHORIZATION: 'authorizationCodes/EDIT_AUTHORIZATION',
}

export default actions
